export enum InternalDirectAction {
    Nothing = 0,
    MarkCompleted = 1,
    ChangeDonationDate = 2
}

export const internalDirectActionList = [
    { action: InternalDirectAction.MarkCompleted, title: 'Mark Donation Completed' },
    { action: InternalDirectAction.ChangeDonationDate, title: 'Set New Donation Date' },
];